/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

// export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD'
export const LOADER_STATUS = "EWAY_BILL/LOADER_STATUS";
export const PROFILE_INFO = "EWAY_BILL/PROFILE_INFO";
export const SET_VARIANCE_DATA = "EWAY_BILL/SET_VARIANCE_DATA";
export const SET_EWAY_RECO_TAX = "EWAY_BILL/SET_EWAY_RECO_TAX";
export const SET_EWAY_RECO_TURNOVER = "EWAY_BILL/SET_EWAY_RECO_TURNOVER";
export const SET_EINVOICE_RECO_TAX = "EWAY_BILL/SET_EINVOICE_RECO_TAX";
export const SET_EINVOICE_RECO_TURNOVER =
  "EWAY_BILL/SET_EINVOICE_RECO_TURNOVER";
export const SET_CLEAR_GRAPH = "EWAY_BILL/SET_CLEAR_GRAPH";
